// extracted by mini-css-extract-plugin
module.exports = {"fullwidth":"InvoicesCreate_fullwidth__1PbTT"};